import unescapedText from 'I18n/utils/unescapedText';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import IconTypes from 'ContentUtils/constants/IconTypes';
export function getIconNameForLookup(name) {
  return name && name.toLowerCase();
}
export default function formatIconName(name, selectedIcons) {
  const compatibleName = getIconNameForLookup(name);
  let iconName = name;
  if (compatibleName && selectedIcons[compatibleName]) {
    const {
      categories
    } = selectedIcons[compatibleName];
    const i18nKey = `ContentComponents.iconNames.${compatibleName}`;
    if (!categories.includes(IconTypes.BRAND) && isValidI18nKey(i18nKey)) {
      iconName = unescapedText(i18nKey);
    }
  }
  return iconName.charAt(0).toLocaleUpperCase() + iconName.slice(1);
}